export interface TableViewPreferences {
  hiddenColumns?: string[];
  pageSize?: number;
  sorting?: { id: string; desc: boolean }[];
}

type PreferencesMap = Record<string, TableViewPreferences>;

const STORAGE_KEY = 'df_view_preferences_v1';

/** Read whole storage */
function readStorage(): PreferencesMap {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    return JSON.parse(raw);
  } catch {
    return {};
  }
}

/** Write whole storage */
function writeStorage(data: PreferencesMap) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
}

/** Get preferences for a table */
export function getTablePreferences(modelKey: string): TableViewPreferences {
  const storage = readStorage();
  return storage[modelKey] ?? {};
}

/** Update preferences partially */
export function updateTablePreferences(modelKey: string, update: TableViewPreferences) {
  const storage = readStorage();

  storage[modelKey] = {
    ...storage[modelKey],
    ...update,
  };

  writeStorage(storage);
}

/**
 * Clear — called from `resetClientState()` on logout.
 *
 * These are per-model column/filter/sort preferences of the signed-in user, not
 * a device setting: which columns someone hides on `/outbound` is theirs, and on
 * a shared workstation the next user should start from the defaults.
 */
export function clearTablePreferences() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore disabled storage */
  }
}
